import styled from 'styled-components'

export const Wrapper = styled.div`
  padding: 24px;
  background: #f0f2f5;
  min-height: 100vh;
`

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  h2 {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
  }
`

export const FiltersRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`

export const TableWrapper = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02);

  .ant-table-thead > tr > th {
    background: #fafafa;
    font-weight: 600;
  }
`

export const ActionsCell = styled.div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
`

export const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 8px 16px;

  dt {
    font-weight: 600;
    color: rgba(0, 0, 0, 0.65);
  }

  dd {
    margin: 0;
    color: rgba(0, 0, 0, 0.85);
  }
`
